/* eslint-disable @typescript-eslint/no-explicit-any */
import { QUIZ_MODES, EQuizStatus } from '@constants';
import { IQuizUserFilters } from '@sdk/contracts';
import { Button, Popover } from 'antd';
import { Checkbox, Collapse } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Wrapper } from './FiltersHandler.styles';

import { SectionSearchSelector } from '@/components/Form';
import { Icon } from '@/components/Icon';
import { useMyQuizzesList } from '@/store';

export const FiltersHandler = () => {
  const { t } = useTranslation(['ManagerQuizzesTranslations', 'DefaultTranslations']);
  const { filter, setFilter } = useMyQuizzesList();

  const statusOptions = useMemo(
    () =>
      Object.values(EQuizStatus).map(s => ({
        label: t(`ManagerQuizzesTranslations:${s}`),
        value: s
      })),
    [t]
  );

  const modeOptions = useMemo(
    () =>
      QUIZ_MODES.map(s => ({
        label: t(`ManagerQuizzesTranslations:${s}`),
        value: s
      })),
    [t]
  );

  const handleSetFilters = (key: keyof IQuizUserFilters, value: any) => {
    if (value) return setFilter({ ...filter, [key]: value });
    clearFilter(key);
  };

  const clearFilter = (key: keyof IQuizUserFilters) => {
    const updatedFilters = { ...filter };
    delete updatedFilters[key];
    setFilter({ ...updatedFilters });
  };

  const content = (
    <Wrapper>
      <Collapse
        ghost
        bordered={false}
        expandIconPosition="end"
        expandIcon={({ isActive }) => <Icon i={isActive ? 'SubtractAlt' : 'AddAlt'} />}>
        <Collapse.Panel key="status" header={t('ManagerQuizzesTranslations:STATUS')}>
          <Checkbox.Group
            value={filter?.status}
            options={statusOptions}
            onChange={v => handleSetFilters('status', v)}
          />
        </Collapse.Panel>
        <Collapse.Panel key="mode" header={t('ManagerQuizzesTranslations:MODE')}>
          <Checkbox.Group
            value={filter?.mode}
            options={modeOptions}
            onChange={v => handleSetFilters('mode', v)}
          />
        </Collapse.Panel>
        <Collapse.Panel key="section" header={t('ManagerQuizzesTranslations:SECTION')}>
          <SectionSearchSelector
            allowClear
            mode="multiple"
            value={filter?.sections}
            courseId={filter?.courses?.[0]}
            onChange={v => handleSetFilters('sections', v)}
          />
        </Collapse.Panel>
      </Collapse>
    </Wrapper>
  );

  return (
    <Popover trigger={['click']} content={content} placement="bottomRight">
      <Button icon={<Icon i="Filter" />}>{t('ManagerQuizzesTranslations:FILTERS')}</Button>
    </Popover>
  );
};
